import { collection, getDocs, addDoc } from "firebase/firestore";
import { db } from "./firebase";

// Export deities and contents as JSON
export async function exportData() {
  const deitiesSnap = await getDocs(collection(db, "deities"));
  const contentsSnap = await getDocs(collection(db, "contents"));
  const deities = deitiesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  const contents = contentsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  return JSON.stringify({ deities, contents }, null, 2);
}

// Import JSON data (expects { deities: [...], contents: [...] })
export async function importData(json) {
  const data = typeof json === "string" ? JSON.parse(json) : json;
  for (const deity of data.deities || []) {
    await addDoc(collection(db, "deities"), deity);
  }
  for (const content of data.contents || []) {
    await addDoc(collection(db, "contents"), content);
  }
}